module.exports = __webpack_public_path__ + "static/media/Rzeczpospolita.4b82af37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rzeczpospolita.svg
// module id = 628
// module chunks = 0